module.exports = {
	"da": {
		"hqm": {
			"support-button": "Få hjælp",
			"support-page": {
				"create-ticket": {
					"title": "Få hjælp",
					"instructions": "Indsend en anmodning herunder, og vi vil vende tilbage til dig.",
					"fields": {
						"mid": {
							"label": "Vælg butik",
							"validation": "Butik skal udfyldes"
						},
						"topic": {
							"question": "Hvad drejer dit spørgsmål sig om?",
							"label": "Vælg et emne",
							"validation": "Emne skal vælges",
							"options": {
								"orders": "Bestillinger",
								"settlements": "Afregninger",
								"agreements": "Aftaler",
								"technical_issues": "Tekniske problemer",
								"others": "Andre"
							}
						},
						"subject": {
							"label": "Genstand",
							"validation": "Genstand skal udfyldes"
						},
						"description": {
							"label": "Meddelelse",
							"validation": "Beskrivelse skal udfyldes"
						},
						"attachment": {
							"label": "Tilføjede vedhæftninger",
							"button": "Overfør",
							"info": "Skærmbilleder vil hjælpe os med at løse problemet hurtigere.",
							"supportedFileTypes": "Understøttede filtyper: .png, .jpg, .pdf",
							"error": "Den samlede filstørrelse må ikke overskride 15 MB"
						}
					},
					"submit": "Indsend anmodning",
					"service-unavailable-error": "Hov! Noget gik galt. Prøv igen om et øjeblik. {link} for hjælp, hvis problemet fortsætter.",
					"contact-page-link": "Kontakt os"
				},
				"view-ticket": {
					"title": "Udført!",
					"details": "Vi har modtaget din anmodning, og vi vil sende dig et svar om kort tid. Her er dine oplysninger:",
					"ticket": "Anmodningsnr. {ticketId}",
					"email": "E-mail: {email}",
					"status": "Du kan spore status på vores supportside.",
					"track": "Spor status"
				}
			},
			"popup": {
				"yes": "Ja",
				"no": "Nej",
				"somethingElse": "Jeg har brug for hjælp med noget andet"
			},
			"header": {
				"homeLink": "Nulstil"
			},
			"home": {
				"greeting": "Hej {givenName}! Hvordan kan vi hjælpe dig?",
				"topics": "Hvad har du brug for hjælp med?"
			},
			"topics": {
				"expandButton": "Mere"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Vi beklager, at dette ikke hjalp. Måske kan nogle af disse artikler hjælpe dig?",
				"stillQuestionsTitle": "Har du flere spørgsmål?",
				"stillQuestionsParagraph": "Du kan også kontakte os direkte.",
				"contactButton": "Kontakt os"
			},
			"feedback": {
				"title": "Hjalp dette?",
				"optionYes": "Ja, det hjalp",
				"optionNo": "Nej, jeg har brug for mere hjælp",
				"positiveFeedback": "Tak for den positive feedback. Det hjælper os med at give dig mere relevante artikler i fremtiden."
			},
			"freeTextFeedback": {
				"title": "Hjælp os med at blive bedre",
				"placeholder": "Hvorfor fandt du ikke dette indhold hjælpsomt?",
				"submitButton": "Send",
				"feedbackMessage": "Tak for din feedback. Det hjælper os med at give dig mere relevante artikler i fremtiden."
			},
			"relatedContent": {
				"title": "Forbundet indhold"
			},
			"search": {
				"buttonLabel": "Søg",
				"input": "Søg efter artikler ...",
				"loading": "Indlæser ...",
				"results": {
					"contact": "Kan du ikke finde det indhold, du har brug for?",
					"empty": "Beklager, vi fandt ikke nogen resultater for din forespørgsel. Prøv at søge igen efter et andet udtryk.",
					"singleTopicFound": "Vi fandt ét emne",
					"multipleTopicsFound": "Vi fandt {count} emner",
					"singleArticleFound": "Vi fandt ét artikel",
					"multipleArticlesFound": "Vi fandt {count} artikler"
				}
			},
			"contact": {
				"title": "Kontakt os",
				"channelsIntro": "Kontakt os, så vi kan hjælpe dig.",
				"businessDetailsTitle": "Dine forretningsoplysninger",
				"businessDetailsName": "Forretningsnavn",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "Butik-ID",
				"phone": {
					"title": "Ring til os",
					"paragraph": "Du kan ringe til os i åbningstiden på hverdage. Hvis du befinder dig i Sverige eller Storbritannien, kan du også ringe til os i weekenden mellem 10.00-16.00."
				},
				"chat": {
					"title": "Chat med os",
					"paragraph": "Den hurtigste og letteste måde at nå support på. Vores chat er åben nu.",
					"button": "Åbn chat"
				},
				"email": {
					"title": "Send os en e-mail",
					"paragraph": "Send os en e-mail, og vi vil vende tilbage til dig, så snart vi kan."
				}
			},
			"errorBoundary": {
				"title": "Noget gik galt.",
				"message": "Vi beklager, men der var en fejl. Du kan klikke på knappen herunder for at nulstille og lukke denne sidebjælke.",
				"resetButton": "Nulstil",
				"errorId": "Fejl-ID: {errorId}"
			},
			"tour": {
				"prev": "Forrige",
				"next": "Næste",
				"done": "Udført"
			},
			"notAvailableMobile": {
				"title": "Ikke tilgængelig",
				"buttonBack": "Tilbage",
				"paragraph": "Dette indhold er ikke tilgængelig på denne enhed. Prøv at åbne på en enhed med en større skærmstørrelse såsom en computer."
			},
			"shareButton": {
				"title": {
					"article": "Del et dybt link til denne artikel",
					"topic": "Del et dybt link til denne emne",
					"tour": "Del et dybt link til denne tur"
				},
				"radioItemHome": "Hjemmeapp",
				"descriptionHome": "Åbner hjælpeartiklen på forhandlerportalens hjemmeside",
				"radioItemCurrent": "Aktuel side",
				"descriptionCurrent": "Åbner hjælpeartiklen på den nuværende side"
			}
		},
		"orientation": {
			"title": "Lær hvordan man laver ..."
		},
		"core": {
			"alert": {
				"message": "Noget gik galt. Prøv igen.",
				"correlationIdLabel": "Korrelations-ID"
			},
			"header": {
				"title": "Butiksportal"
			},
			"usermenu": {
				"language": "Sprog",
				"country": "Land",
				"timezone": "Tidszone",
				"logout": "Log ud",
				"profile": "Profil",
				"changeProfile": "Rediger",
				"tooltip": "Din profil"
			},
			"appsmenu": {
				"defaultTooltip": "Dine apper",
				"initialTooltip": "Find dine apper her.",
				"newAppsTooltip": "Vi har nye apper til dig!"
			},
			"helpful-question-mark": {
				"helpLabel": "Hjælp"
			},
			"languages": {
				"da": "Dansk",
				"de": "Tysk",
				"en": "Engelsk",
				"en_GB": "Engelsk (GB)",
				"en_US": "Engelsk (US)",
				"es": "Spansk",
				"fi": "Finsk",
				"fr": "Fransk",
				"it": "Italiensk",
				"nl": "Hollandsk",
				"no": "Norsk",
				"sv": "Svensk"
			},
			"countries": {
				"de": "Tyskland",
				"dk": "Danmark",
				"fi": "Finland",
				"gb": "Storbritannien",
				"nl": "Holland",
				"no": "Norge",
				"se": "Sverige",
				"us": "USA"
			},
			"selectLanguage": {
				"title": "Vælg dit sprog",
				"paragraph": "Dette bliver dit standardsprog.",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Vælg dit land",
				"paragraph": "Dette bliver dit standardland.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Opdater oplysninger",
				"submit": "OK",
				"emailLabel": "E-mailadresse",
				"firstNameLabel": "Fornavn",
				"lastNameLabel": "Efternavn",
				"resetPasswordLabel": "Nulstil adgangskode",
				"resetPasswordSuccessLabel": "E-mail til nulstilling af adgangskode sendt",
				"resetPasswordErrorLabel": "Fejl i forbindelse med afsending af e-mail til nulstilling af adgangskode",
				"error": "Fejl i forbindelse med opdatering af oplysninger"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle rettigheder forbeholdes",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Vilkår og betingelser"
			},
			"accessDenied": {
				"title": "Du skal have yderligere adgang for at se denne side.",
				"message": "Kontakt din administrator eller Klarna, hvis du har spørgsmål."
			},
			"midSelector": {
				"label": "Butik"
			},
			"storeSelector": {
				"label": "Butik"
			},
			"storesSelector": {
				"closeText": "Udført",
				"closeTextWithSelection": "Påfør # valg",
				"deselectAllOptionText": "Slet valg",
				"emptyStateText": "Ingen butikker blev fundet",
				"label": "Butikker",
				"searchFieldLabel": "Søg efter butik",
				"selectAllOptionText": "Vælg alle butikker",
				"selectedAllText": "Alle butikker",
				"selectedText": "# Antal butikker"
			},
			"pagination": {
				"ofLabel": "af",
				"noResultsLabel": "Ingen resultater"
			},
			"dateRangePicker": {
				"startLabel": "Startdato",
				"endLabel": "Slutdato",
				"months": {
					"january": "Januar",
					"february": "Februar",
					"march": "Marts",
					"april": "April",
					"may": "Maj",
					"june": "Juni",
					"july": "Juli",
					"august": "August",
					"september": "September",
					"october": "Oktober",
					"november": "November",
					"december": "December"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "T",
					"wednesday": "O",
					"thursday": "T",
					"friday": "F",
					"saturday": "S",
					"sunday": "S"
				}
			},
			"appIcon": {
				"newLabel": "NYHED"
			},
			"appCategory": {
				"dayToDay": "Til dine daglige",
				"nko": "Klarna Online",
				"tools": "Værktøjer",
				"preferences": "Indstillinger"
			},
			"apps": {
				"home-fe": {
					"title": "Hjem"
				},
				"nko-app": {
					"title": "Klarna Online apper"
				},
				"orders-fe": {
					"title": "Bestillinger",
					"description": "Søg og administrer dine ordrer fra Klarna.",
					"nkoLinkText": "Tilgå ældre ordrer"
				},
				"nko-orders": {
					"title": "Ordrer (KO)",
					"description": "Søg og administrer de ordrer, du har lagt gennem Klarna Online."
				},
				"settlements-fe": {
					"title": "Afregninger",
					"description": "Se dine transaktioner og generér rapporter til forsoning.",
					"nkoLinkText": "Tilgå ældre rapporter"
				},
				"nko-settlements": {
					"title": "Afregninger (KO)",
					"description": "Find rapporter om bestillinger og udbetalinger fra Klarna Online."
				},
				"logs-app-fe": {
					"title": "Logge",
					"description": "Søg i API-logge for at fejlbehandle integrationsproblemer."
				},
				"users-fe": {
					"title": "Brugere",
					"description": "Inviter nye brugere, og administrer eksisterende brugere i portalen."
				},
				"settings-fe": {
					"title": "Indstillinger",
					"description": "Anmod om dine API-brugeroplysninger, og administrer butiksindstillinger."
				},
				"nko-settings": {
					"title": "Indstillinger (KO)",
					"description": "Administrer dine butiksindstillinger, rapporter og kontaktoplysninger."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Opret nye ordrer med Klarnas løsning i butikken."
				},
				"products-fe": {
					"title": "Produkter",
					"description": "Vejleder dig på din vej til at få mest muligt ud af Klarna."
				},
				"upstream-fe": {
					"title": "On-site messaging",
					"description": "Sælg mere med tilpassede og personrettede finansieringstilbud."
				},
				"lending-fe": {
					"title": "Virksomhedslån",
					"description": "Vi har gjort virksomhedsfinansiering så enkelt så muligt."
				},
				"branding-fe": {
					"title": "Branding",
					"description": "Tag kontrol over, hvordan dit brand præsenteres med Klarna."
				},
				"disputes-fe": {
					"title": "Tvister",
					"description": "Håndter dine tvister."
				},
				"logistics-fe": {
					"title": "Logistik",
					"description": "Administrer al din logistik på ét sted."
				},
				"ob-transactions-fe": {
					"title": "Transaktioner",
					"description": "Åbne banktransaktioner"
				},
				"developers": {
					"title": "Udviklere"
				},
				"product-upgrade-fe": {
					"title": "Produktopgradering"
				},
				"marketing": {
					"title": "Markedsføring",
					"description": "Hent markedsføringsaktiver her, så din forretning kan vokse."
				},
				"business-card-fe": {
					"title": "Visitkort",
					"description": "Kommer snart"
				},
				"support": {
					"title": "Support",
					"description": "Tjek og administrer dine supportanmodninger."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Tilbage"
				}
			},
			"errorBoundary": {
				"contact": "Prøv at genindlæse siden. {br}Hvis fejlen fortsætter, så kontakt <supportLink>Butikssupport</supportLink> sammen med fejl-id {errorId}",
				"errorDescription": "Fejl-ID - {errorId}",
				"reloadButton": "Genindlæs",
				"title": "Der er desværre opstået en fejl"
			},
			"maintenance": {
				"pageTitle": "Vedligeholdelse",
				"title": "Butiksportalen er i øjeblikket under planlagt vedligeholdelse",
				"summary": "Vi vender snart tilbage",
				"scheduledSummary": "Vi vender tilbage {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "En af de vigtigste salgsdage nærmer sig. I løbet af Black Friday vil vi være her for at levere nærtidsstatistik for dine salg. Lad os i mellemtiden berede os på succes.",
				"countdown": "Begynder om #dt #hh #mm #ss…",
				"box1": {
					"title": "3,5 gange højere forbrug*",
					"text": "Sidste år brugte Klarna-kunder* gennemsnitligt 3,5 gange mere på Black Friday end de gjorde på nogen anden dag i løbet af året.",
					"footnote": "*Gennemsnit på tværs af alle Klarna-forhandlerkategorier og regioner."
				},
				"box2": {
					"title": "2,5 gange højere salgsmængde*",
					"text": "Sidste år indbragte Klarna-forhandlere en 2,5 gange højere salgsmængde på Black Friday end på nogen anden dag i året.",
					"footnote": "*Gennemsnit på tværs af alle Klarna-forhandlerkategorier og regioner."
				},
				"sectionTitle": "Lad os øge din omsætning for Black Friday",
				"marketing": {
					"title": "Markedsfør din forretning før og på Black Friday",
					"text": "Få flere handlende i din forretning i løbet af Black Friday-sæsonen med disse gratis ressourcer til sociale medier og e-mailkampagner."
				},
				"branding": {
					"title": "Bliv set i Klarna-appen",
					"text": "12 millioner handlende bruger Klarna-appen hver måned. Sørg for, at du brillerer i appen denne Black Friday ved at tilføje og opdatere dine mærkeoplysninger her i forhandlerportalen."
				},
				"cta": "Kom i gang",
				"close": "Luk"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Ordremængde",
				"orderCountTitle": "Oprettede ordrer",
				"orderCount": "{count} ordrer",
				"box": {
					"title": "Ønsker du at øge din omsætning yderligere?",
					"subtitle1": "On-site messaging",
					"subtitle2": "Reklamemeddelelser der informerer.",
					"text": "Vores On-site messaging-værktøj hjælper med at øge dit salg og din gennemsnitlige ordreværdi med reklamemeddelelser. Fortæl dine kunder, hvad deres betalingsmuligheder er, så snart de ankommer på din side og hele vejen gennem deres købsoplevelse.",
					"cta": "Kom i gang"
				},
				"selector": {
					"done": "Udført",
					"applySelection": "Påfør # valg",
					"selectAll": "Vælg alle",
					"allOptions": "Alle muligheder valgt",
					"someOptions": "# muligheder valgt",
					"storeMultiSelectLabel": "Vælg # butikker",
					"allStores": "Alle butikker"
				},
				"currencyLabel": "Vælg valuta",
				"storeLabel": "Vælg butik"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Dette er dit salg fra en af årets vigtigste salgsuge.",
				"summaryTitle": "Sammenfatning",
				"orderVolume": "Samlet mængde",
				"orderCount": "Ordrer i alt",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "sammenlignet med samme dag i sidste uge",
				"tabs": {
					"monday": "Mandag",
					"tuesday": "Tirsdag",
					"wednesday": "Onsdag",
					"thursday": "Torsdag",
					"blackFriday": "Black Friday",
					"saturday": "Lørdag",
					"sunday": "Søndag",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};